import React, { ReactChild, useMemo } from 'react'
import { useLocation } from 'react-router-dom'


export const HeaderPage = ({name,button}:Props) => {
    const path = useLocation()
    
    const renderBrand = useMemo(():string => {
        let strpath = path.pathname
        if(strpath === "/admin") return "Geral"
        if(strpath === "/osc") return ""
        
        strpath = strpath.replace("/admin/","")
        strpath = strpath.replace("/osc/","")
        strpath = strpath.replace("novo","Adicionar")
        strpath = strpath.replace("-"," ")
        
        return strpath.toLowerCase()
		.split('/')
		.map((word) => {
            if(!parseInt(word))
			return word[0].toUpperCase() + word.slice(1);
            return ""
		}).join(' / ')
       
    },[path])
    return(
        <div className='w-full mb-10'>
            <div className='text-gray-600'>{renderBrand}</div>
        <div className='flex justify-between w-full'>
            
            <div className='text-2xl font-bold mt-2'>{name}</div>
            <div>
              {button && button}
            </div>
        </div>
        </div>
    )
}
interface Props {
    name:string
    button?:ReactChild
    
}